import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon/SvgIcon';
import { isString } from 'lodash';
import React, { createElement, FC } from 'react';

import { useStyles } from './EndMenuItemIcon.styles';

interface EndMenuItemIconProps {
  icon: string | OverridableComponent<SvgIconTypeMap>;
}

export const EndMenuItemIcon: FC<EndMenuItemIconProps> = ({ icon }) => {
  const { classes } = useStyles();

  if (!icon) {
    return null;
  }

  if (isString(icon)) {
    return (
      <i className={classes.root}>
        <img className={classes.icon} src={icon} alt={icon} width="15" height="15" />
      </i>
    );
  }

  return <i className={classes.root}>{createElement(icon, { className: classes.icon })}</i>;
};
